/* NEXORA — Cinematic intro controller. The page is fully rendered underneath at all times. */
(function () {
  var el = document.querySelector('[data-nx-intro]');
  if (!el) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) { el.remove(); return; }

  // Never replay inside the Shopify theme editor preview on every re-render.
  var once = el.dataset.once === 'true';
  var KEY = 'nx-intro-seen';
  try {
    if (once && sessionStorage.getItem(KEY) === '1') { el.remove(); return; }
  } catch (e) { /* private mode: just play it */ }

  var duration = parseFloat(el.dataset.duration || '1.4');
  if (isNaN(duration) || duration <= 0) duration = 1.4;

  el.style.setProperty('--nx-d', duration + 's');
  el.style.setProperty('--nx-fx', (el.dataset.focusX || 74) + '%');
  el.style.setProperty('--nx-fy', (el.dataset.focusY || 50) + '%');

  var finished = false;
  function finish() {
    if (finished) return;
    finished = true;
    el.classList.add('is-done');
    document.documentElement.classList.remove('nx-intro-locked');
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    setTimeout(function () { el.remove(); }, 500);
  }

  el.hidden = false;
  document.documentElement.classList.add('nx-intro-locked');

  requestAnimationFrame(function () {
    el.classList.add('is-playing');
  });

  el.querySelector('[data-nx-intro-skip]')?.addEventListener('click', finish);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') finish();
  });

  // Hard stop: whatever happens, the site is never blocked for longer than the animation.
  setTimeout(finish, duration * 1000 + 120);
})();
